<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    back() {
      return window.history.back();
    },

    openWhatsApp(phone) {
      window.location.href = "https://wa.me/" + phone;
    }
  },

  created() {
    // 进入页面后直接跳转客服
    window.location.href =
        "https://sjl.dot03jgz.lol/chat/index?channelId=79c01d6ece5a43cdafa8ed450ff1b5f2";
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #211923 url("https://xhtd888.oss-cn-hongkong.aliyuncs.com/uu8/sts/hk_login.png") no-repeat top center;
  background-size: cover;
}

.page::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background:
      linear-gradient(180deg, rgba(18,14,20,.25) 0%, rgba(44,25,47,.55) 48%, rgba(88,53,83,.82) 100%),
      rgba(30,20,33,.25);
}

.page > * {
  position: relative;
  z-index: 1;
}

.nav-bar {
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
}

::v-deep .van-nav-bar__left {
  left: 18px;
}

::v-deep .van-icon-arrow-left {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255,255,255,.18);
  font-size: 40px !important;
}

.service-wrap {
  padding: 70px 26px 40px;
}

.wa-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px 28px;
  margin-bottom: 22px;
  border-radius: 24px;
  background: rgba(112, 99, 110, 0.72);
  border: 1px solid rgba(255,255,255,.16);
  box-shadow:
      0 18px 34px rgba(0,0,0,.22),
      inset 0 1px 0 rgba(255,255,255,.22);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.wa-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.wa-icon {
  width: 76px;
  height: 76px;
  border-radius: 22px;
  background: linear-gradient(135deg, #28d146 0%, #1faa52 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 24px rgba(33,192,99,.28);
  flex-shrink: 0;
}

.wa-info {
  margin-left: 20px;
  flex: 1;
  min-width: 0;
}

.wa-title {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 8px;
}

.wa-number {
  font-size: 32px;
  font-weight: 900;
  color: #ff4f94;
  line-height: 1.35;
  word-break: break-all;
}

.wa-right {
  display: flex;
  align-items: center;
  margin-left: 12px;
  flex-shrink: 0;
}

.wa-open {
  min-width: 82px;
  height: 38px;
  padding: 0 14px;
  margin-right: 8px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f26b6f 0%, #e33983 100%);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  box-shadow: 0 8px 18px rgba(227,57,131,.32);
}

.wa-right .van-icon {
  color: rgba(255,255,255,.75) !important;
}
</style>